import { LEAVE_STATUSES } from 'domain/shared/leave';
import { FieldProps, useFieldHelper, EnumField } from 'framework/ui/field';

interface LeaveStatusFieldProps extends FieldProps {
  value?: Nullable<string>;
  source?: Nullable<string>;
  label?: Nullable<string>;
}

const LeaveStatusField = ({ value: inputValue = null, source = null, label = null }: LeaveStatusFieldProps) => {
  const { getValue } = useFieldHelper({ value: inputValue, source });

  const value = inputValue || (getValue && getValue());

  return <EnumField label={label} value={value} options={LEAVE_STATUSES} />;
};

export default LeaveStatusField;
